module.exports = __webpack_public_path__ + "static/img/im1.27073381.png";